import script from "./ViewerBottomSheet.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewerBottomSheet.vue?vue&type=script&setup=true&lang=ts"

import "./ViewerBottomSheet.vue?vue&type=style&index=0&id=7f858226&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f858226"]])

export default __exports__